module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/tankodrome-lvl1-75.79d52870.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/tankodrome-lvl1-75.png
// module id = 3554
// module chunks = 11